import React, { useState, useEffect, useCallback } from "react";
import { useMemo, useRef } from "react";
import { Grid, Tooltip } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import SearchIcon from "@material-ui/icons/Search";
import { CloseOutlined } from "@material-ui/icons/";
// import Loader from "../../biztran_controls/Loader";

const columns = [
    {
        field: "ModelCode",
        headerName: "ModelCode",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
    },
    {
        field: "Quantity",
        headerName: "Qty",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 130,
        type: "number",
        editable: true,
        renderCell: (params) => (
            <Tooltip title={params.row.Quantity} >
                <span className="table-cell-trucate">
                    {/* {params.row.Quantity != 1 || params.row.Quantity != 0 ? 1 : params.row.Quantity} */}
                    {params.row.Quantity > 1 ? params.row.Quantity : 1}
                </span>
            </Tooltip>
        )
    },
    {
        field: "Description",
        headerName: "Description",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 260,
        renderCell: (params) => (
            <Tooltip title={params.row.Description} >
                <span className="table-cell-trucate">{params.row.Description}</span>
            </Tooltip>
        )
    },
    {
        field: "StockQty",
        headerName: "SInQty",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
        type: "number",
    },
    {
        field: "ListPriceINR",
        headerName: "Rate",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
        type: "number",
    },
    {
        field: "Amount",
        headerName: "Amount",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
        type: "number",
        valueGetter: GetAmount,
    },
    {
        field: "ProductName",
        headerName: "Product",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
        renderCell: (params) => (
            <Tooltip title={params.row.ProductName} >
                <span className="table-cell-trucate">{params.row.ProductName}</span>
            </Tooltip>
        )
    },
    {
        field: "ProductCat1",
        headerName: "Cat1",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
        renderCell: (params) => (
            <Tooltip title={params.row.ProductCat1} >
                <span className="table-cell-trucate">{params.row.ProductCat1}</span>
            </Tooltip>
        )
    },

];


function useApiRef() {
    // debugger;
    const apiRef = useRef(null);
    const _columns = useMemo(
        () =>

            columns.concat({
                field: "__HIDDEN__",
                width: 0,
                renderCell: (params) => {
                    apiRef.current = params.api;
                    return null;
                },
            }),
        [columns]
    );
    return { apiRef, columns: _columns };
}



function GetAmount(params) {
    var Q = params.getValue(params.id, "Quantity");
    var R = params.getValue(params.id, "ListPriceINR");
    let Total = Q * R;
    return Total;
}

// function GetQuantity(params) {
//// debugger;
// var Q = "1";
// var Q = params.getValue(params.id, "Quantity");;
// if (params.getValue(params.id, "Quantity" != undefined)) {
//   Q = params.getValue(params.id, "Quantity");
// }
//   return Q;
// }


const AddProduct = (props) => {
    debugger;
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [cellchanged, setCellchanged] = React.useState([]);
    const [List, setList] = useState([]);
    const [Count, setCount] = useState("");
    const [rows, setRows] = useState([]);
    const [row, setRow] = useState([]);
    const { apiRef, columns } = useApiRef();
    const [Mode, setMode] = useState("");
    const [Column, setColumn] = useState("");
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [isEditOpen, setEditOpen] = useState();
    const [IDID, SetIDID] = useState(props.IDID);
    const [response, fetchData] = UseFetchData();
    const [ProductListresponse, FetchProductListData] = UseFetchData();
    const [Productcmb, setProductcmb] = useState([]);
    const [ProductGroupcmb, setProductGroupcmb] = useState([]);
    const [ProductCat1cmb, setProductCat1cmb] = useState([]);
    const [ProductID, setProductID] = useState("");
    const [ProductGroupID, setProductGroupID] = useState("");
    const [ProductCat1ID, setProductCat1ID] = useState("");
    const [Description, setDescription] = useState("");
    const [SearchString, setSearchString] = useState("");
    const [loading, setLoading] = useState(true);
    const [pageName, setpageName] = useState(props.pageName);
    const [DocumentType, setDocumentType] = useState("");
    const [TransactionType, setTransactionType] = useState("");
    const [DocumentDate, setDocumentDate] = useState("");
    const [TransactionStoreID, setTransactionStoreID] = useState("");
    const [StateResponse, fetchState] = UseFetchData();
    // const [StockResponse, fetchStocK] = UseFetchData();



    useEffect(() => {
        setLoading(false);
        setRows(ProductListresponse);
    }, [ProductListresponse]);


    const validationSchema = Yup.object({
    });


    useEffect(() => {
        debugger;
        if (props.IDDtlsData != null && props.IDDtlsData.length > 0) {
            setLoading(false);
            setRow(props.IDDtlsData);
        }
    }, [props.IDDtlsData]);

    const onSubmit = async () => {
        debugger;
        try {
            let gridcolumns = apiRef.current.getRowModels();
            var newSelection = selectionModel;
            let Seq = 0;
            if (selectionModel.length > 0) {
                for (var i = 0; i < newSelection.length; i++) {
                    var idd = newSelection[i];
                    let iterator = gridcolumns.entries();
                    for (let e of iterator) {
                        var id = e[0];
                        if (idd === id) {
                            Seq += 1;
                            let Quty = 1;
                            let OutQuty = 0;
                            let Quantitys = e[1].Quantity;
                            let Rate = e[1].ListPriceINR;
                            var bodyFormData = new FormData();
                            var IDDID = "";
                            if (pageName == "SAM") {
                                for (var i = 0; i < newSelection.length; i++) {
                                    if (newSelection.length > 1) {
                                        alert("Only one Product Can Modified At a Time!");
                                    }
                                    else {
                                        // var idd = newSelection[i];
                                        let iterator = gridcolumns.entries();
                                        for (let e of iterator) {
                                            var id = e[0];
                                            if (idd === id) {
                                                let Model_Code = e[1].ModelCode
                                                let Description = e[1].Description
                                                let ProductName = e[1].ProductName
                                                let SInQty = e[1].StockQty
                                                var IDDID = "";
                                                if (ProductGroupID != "") {
                                                    props.setProductID(e[1].ProductID);
                                                }
                                                else {
                                                    props.setProductID(ProductID);
                                                }
                                                props.setProductSKUID(id);
                                                props.setModelCode(Model_Code);
                                                props.setDescription(Description);
                                                props.setProduct(ProductName);
                                                props.setBookQty(SInQty);
                                                props.setOpen(false);
                                            }
                                        }
                                    }
                                }
                            }
                            else {

                                if (props.StockID != undefined && props.StockID == "" && props.StockID == null) {
                                    bodyFormData.append("StockID", props.StockID);
                                }
                                else {
                                    bodyFormData.append("StockID", IDDID);
                                }
                                bodyFormData.append("InventoryDocumentID", IDID);
                                bodyFormData.append("SerialNumber", Seq);
                                bodyFormData.append("ProductSKUID", id);
                                if (Quantitys == undefined && Quantitys == null) {
                                    bodyFormData.append("InQty", parseFloat(Quty));
                                }
                                else {
                                    bodyFormData.append("InQty", parseInt(e[1].Quantity));
                                }
                                bodyFormData.append("OutQty", parseInt(OutQuty));
                                bodyFormData.append("Rate", parseFloat(Rate));
                                bodyFormData.append("DocumentType", DocumentType);
                                bodyFormData.append("DocumentDate", DocumentDate);
                                bodyFormData.append("TransactionType", TransactionType);
                                bodyFormData.append("StoreID", TransactionStoreID);
                                await fetchData("StockAdjustment/AddProduct", bodyFormData);

                            }
                        }
                    }
                }
                if (pageName == 'NCR') {
                }
                else {
                    alert("Product is Added Sucessfully")
                }
            }
            else {
                alert("Please Select Product To Add");
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (response.Response === true) {
            setProductID("");
            setProductGroupID("");
            props.getByIDData();
            setLoading(false);
        } else if (response.Response === false) {
            if (response.Message.includes("Already") === true) {
                alert(response.Message);
                setLoading(false);

            } else {
                alert("Failed.");
                setLoading(false);

            }
        }
    }, [response]);


    const ProductGroupData = useCallback((options) => {
        if (options !== undefined) {
            let ProductGroup = options.map((data) => (
                <option key={data.ProductGroup} value={data.ProductGroupID}>
                    {data.ProductGroup}
                </option>
            ));
            setProductGroupcmb(ProductGroup);
        }
    }, []);


    const ProductcmbData = (PGID) => {
        debugger;
        var id = "";
        if (PGID !== "") {
            id = PGID;
        } else if (ProductGroupID !== "") {
            id = ProductGroupID;
        } else {
            id = "";
        }
        let options = ComboDataResponse["Product"];
        if (options !== undefined) {
            if (id !== "") {
                let Product = options
                    .filter((option) => option.ProductGroupID === id)
                    .map((data) => (
                        <option key={data.ProductName} value={data.ProductID}>
                            {data.ProductName}
                        </option>
                    ));
                setProductcmb(Product);
            }
            else {
                let Product = options.map((data) => (
                    <option key={data.ProductName} value={data.ProductID}>
                        {data.ProductName}
                    </option>
                ));
                setProductcmb(Product);
            }
        }
    };


    useEffect(() => {
        if ((response.Response === true) && (Mode === 'Insert')) {
            alert('Data Saved Succesfully.');
            props.setOpen(false);
            props.PopulateData();
            setLoading(false);
        }
        else if (response.Response === false) {
            alert('Failed.');
            setLoading(false);
        }
    }, [response]);


    useEffect(() => {
        if (ComboDataResponse !== undefined) {
            if (ComboDataResponse["Product"] !== undefined) {
                setLoading(false);
                ProductcmbData(ComboDataResponse["Product"]);
            }
            else {
                ProductcmbData([]);
            }
            if (ComboDataResponse["ProductGroup"] !== undefined) {
                setLoading(false);
                ProductGroupData(ComboDataResponse["ProductGroup"]);
            }
            else {
                ProductGroupData([]);
            }
            if (props.InventoryDocumentID !== "") {
                ProductcmbData("");
            } else {
            }
        }
    }, [ComboDataResponse]);


    useEffect(() => {
        GetComboData();
    }, [ProductID, ProductGroupID]);

    useEffect(() => {
        GetStateDate();
    }, []);

    const GetStateDate = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("InventoryDocumentID", props.IDID);
        fetchState("StockAdjustment/StateData", bodyFormData);
    }



    useEffect(() => {
        debugger;
        if (StateResponse !== undefined) {
            if (StateResponse["StateData"] !== undefined) {
                setTransactionStoreID(StateResponse["StateData"][0]["TransactionStoreID"]);
                setDocumentDate(StateResponse["StateData"][0]["DocumentDate"]);
                setDocumentType(StateResponse["StateData"][0]["DocumentType"]);
                setTransactionType(StateResponse["StateData"][0]["TransactionType"]);
            }
        }
    }, [StateResponse]);




    const GetComboData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("ProductID", ProductID);
        bodyFormData.append("ProductGroupID", ProductGroupID);
        setLoading(true);
        fetchComboData("StockAdjustment/ComboDataAddProduct", bodyFormData);
    };

    const onSelectChange = (e) => {
        debugger;
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        if (targetvalue !== "") {
            if (targetname === "ProductID") {
                setProductID(targetvalue);
            }
            if (targetname === "ProductGroupID") {
                setProductGroupID(targetvalue);
                ProductcmbData(targetvalue);
            }
        }
        else {
            if (targetname === "ProductID") {
                setProductID("");
            }
            if (targetname === "ProductGroupID") {
                setProductGroupID("");
                setProductcmb([]);
                setProductCat1ID("");
            }

        }
    };

    const PopulateData = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("StockID", props.StockID);
        bodyFormData.append("TransactionStoreID", props.TransactionStoreID);
        bodyFormData.append("ProductID", ProductID);
        bodyFormData.append("ProductGroupID", ProductGroupID);
        bodyFormData.append("Description", Description);
        bodyFormData.append("SearchString", SearchString);
        setLoading(true);
        FetchProductListData("StockAdjustment/ProductList", bodyFormData);
    };


    const handleCellEditCommit = React.useCallback(
        ({ id, field, value }) => {
            // debugger;
            setCellchanged(value)
            if (field === "Amount") {
                const [Quantity, Rate] = value.toString().split(" ");
                const updatedRows = rows.map((row) => {
                    if (row.id === id) {
                        return { ...row, Quantity, Rate };
                    }
                    return row;
                });
                setRows(updatedRows);
            }
        },
        [rows]
    );



    return (
        <Grid xs={12}>
            <Formik
                initialValues={{}}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {(formik) => {
                    return (
                        <Form>
                            <Grid spacing={2} container direction="row" xs={12}>
                                <Grid item xs={1}>
                                    <label
                                        htmlFor={"ProductGroupID"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"ProductGroup"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="select"
                                        name="ProductGroupID"
                                        options={ProductGroupcmb}
                                        onChange={onSelectChange}
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <label
                                        htmlFor={"ProductID"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Product"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="select"
                                        name="ProductID"
                                        options={Productcmb}
                                        onChange={onSelectChange}
                                    />
                                </Grid>
                                <Grid item xs={4}></Grid>
                                <Grid item xs={1}>
                                    <label
                                        htmlFor={"Description"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Description"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="Description"
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <label
                                        htmlFor={"SearchString"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Model_Code"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="SearchString"
                                        onChange={(e) => setSearchString(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <BiztranControls.Button
                                        text="SEARCH"
                                        startIcon={<SearchIcon />}
                                        style={{ marginTop: "0%" }}
                                        onClick={() => {
                                            PopulateData();
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid spacing={2} container direction="row">
                                <Grid xs={12}>
                                    <BiztranControls.DataGrid
                                        rowHeight={25}
                                        rows={rows}
                                        columns={columns}
                                        checkboxSelection
                                        disableSelectionOnClick
                                        onSelectionModelChange={(newSelection) => {
                                            setSelectionModel(newSelection);
                                        }}
                                        onCellEditCommit={handleCellEditCommit}
                                        Height="340px"
                                        Width="100%"
                                    />
                                </Grid>

                                <Grid xs={12} style={{ marginTop: 7 }}>
                                    <div style={{ width: "100%" }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignContent: "center",
                                            }}
                                        >
                                            <BiztranControls.Button
                                                text="Add"
                                                startIcon={<SaveIcon />}
                                                style={{ marginTop: "0%" }}
                                                onClick={() => {
                                                    onSubmit();
                                                }}
                                            />
                                            <BiztranControls.Button
                                                text="Close"
                                                startIcon={<CloseOutlined />}
                                                style={{ marginTop: "0%" }}
                                                onClick={() => props.setOpen(false)}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </Grid>
    );
};

export default AddProduct;
